import { Helmet } from "react-helmet";

const Meta = () => {
  return (
    <Helmet>
      <title>Randi.ai - Brukervilkår</title>
      <meta name="thumbnail" content="https://randi.ai/showcase.jpg" />
      <meta name="robots" content="index, follow" />
      <meta
        name="description"
        content="Les Randi sine brukervilkår som omhandler hvordan tjenesten fungerer, dine rettigheter som bruker og hvordan du må tilpasse deg retningslinjene."
      />
      <meta name="author" content="Randi.ai" />
      <meta name="keywords" content="" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:url" content="https://randi.ai/" />
      <meta name="twitter:title" content="Randi.ai - Brukervilkår" />
      <meta
        name="twitter:description"
        content="Les Randi sine brukervilkår som omhandler hvordan tjenesten fungerer, dine rettigheter som bruker og hvordan du må tilpasse deg retningslinjene."
      />
      <meta name="twitter:image" content="https://randi.ai/showcase.jpg" />

      <meta property="og:url" content="https://randi.ai/" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Randi.ai - Brukervilkår" />
      <meta
        property="og:description"
        content="Les Randi sine brukervilkår som omhandler hvordan tjenesten fungerer, dine rettigheter som bruker og hvordan du må tilpasse deg retningslinjene."
      />
      <meta property="og:image" content="https://randi.ai/showcase.jpg" />
      <link rel="canonical" href="https://randi.ai/" />
    </Helmet>
  );
};

export default Meta;
